// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".success-text[data-v-5c5f84ff]{font-size:25px;font-weight:700}.success-text[data-v-5c5f84ff],.success-text-sub[data-v-5c5f84ff]{margin-top:20px;text-align:center}.success-text-sub[data-v-5c5f84ff]{font-size:17px;font-weight:400}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
